<template>
    <div>
        <div class="titleBox"></div>
        <vx-card title="Licensor 정보" class="mb-6" v-if="dataTemplate.licensor_id">
            
            <ag-grid-vue
            style="min-height:145px; max-height:auto; height: auto;"
            domLayout='autoHeight'
            ref="userTable"
            class="ag-theme-material w-100 ag-grid-table"
            :gridOptions="userTable.gridOptions"
            :columnDefs="userTable.columnDefs"
            :defaultColDef="userTable.defaultColDef"
            :rowData="selectLicensor"
            colResizeDefault="shift"
            suppressMenuHide="false"
            :animateRows="true"
            :floatingFilter="false"
            :suppressPaginationPanel="true"
            >
            </ag-grid-vue>
        </vx-card>
        <vx-card title="신청자 정보" class="mb-6" v-else>
            <div class="vx-row w-full mb-6 items-center">
                <div class="vx-col sm:w-1/6 w-full">
                    <span>이름</span>
                </div>
                
                <div class="vx-row sm:w-1/3 w-full "  >
                    {{ dataTemplate.name }}
                </div>
                <div class="vx-col sm:w-1/6 w-full">
                    <span>소속</span>
                </div>
                <div class="vx-row sm:w-1/3 w-full ">
                    {{ dataTemplate.entity == 'corporation'? "회사" : '개인'}}
                </div>
            </div>
            <div class="vx-row w-full mb-6 items-center">
                <div class="vx-col sm:w-1/6 w-full">
                    <span>이메일</span>
                </div>
                
                <div class="vx-row sm:w-1/3 w-full "  >
                    {{ dataTemplate.email }}
                </div>
                <div class="vx-col sm:w-1/6 w-full">
                <span>전화번호</span>
                </div>
                <div class="vx-row sm:w-1/3 w-full ">
                    {{ dataTemplate.phone}}
                </div>
            </div>
            <div class="vx-row w-full mb-6 items-center">
                <div class="vx-col sm:w-1/6 w-full">
                    <span>거주국가</span>
                </div>
                <div class="vx-row sm:w-1/3 w-full "  >
                    {{ dataTemplate.country }}
                </div>
                <div class="vx-col sm:w-1/6 w-full">
                <span>음원 발매 여부</span>
                </div>
                <div class="vx-row sm:w-1/3 w-full ">
                    {{ dataTemplate.release_experience ? 'Y':'N' }}
                </div>
            </div>
            <div class="vx-row w-full mb-6 items-center">
                <div class="vx-col sm:w-1/6 w-full">
                    <span>발매 앨범 URL</span>
                </div>
                <div class="vx-row sm:w-5/6 w-full "  >
                    <vs-textarea v-model="dataTemplate.url_release" class="w-full " height='100px' placeholder="" disabled/>
                </div>
               
            </div>
            <div class="vx-row w-full mb-6 items-center">
                <div class="vx-col sm:w-1/6 w-full">
                <span>SNS</span>
                </div>
                <div class="vx-row sm:w-5/6 w-full ">
                     <vs-textarea v-model="dataTemplate.url_sns" class="w-full " height='100px' placeholder="" disabled/>
                </div>
            </div>
        </vx-card>
        <vx-card title="관리정보" class="mb-6">
            <div class="w-full vx-row">
                <div class="vx-row w-full mb-6 items-center">
                    <div class="vx-col sm:w-1/6 w-full">
                        <span>접수유형</span>
                    </div>
                    
                    <div class="vx-row sm:w-1/3 w-full "  >
                        {{dataTemplate.source =='member_ddex' ? "DDEX" :
                            dataTemplate.source == "non_member" ? '비회원' :
                            dataTemplate.source == "member"? '회원': '' }}
                    </div>
                    <div class="vx-col sm:w-1/6 w-full">
                        <span>신청 일시</span>
                    </div>
                    <div class="vx-row sm:w-1/3 w-full ">
                        {{fixDate(dataTemplate.created_at, 'yyyy-MM-dd HH:mm:ss')}}
                    </div>
                </div>
                <div class="vx-row w-full mb-6 items-center">
                    <div class="vx-col sm:w-1/6 w-full">
                        관리상태
                    </div>
                    <div class="vx-row sm:w-1/3 w-full " v-html="typeText(dataTemplate.state)">
                        
                    </div>
                    <div class="vx-col sm:w-1/6 w-full">
                        최종상태 변경일시
                    </div>
                    <div class="vx-row sm:w-1/3 w-full " >
                        {{fixDate(dataTemplate.state_updated_at, 'yyyy-MM-dd HH:mm:ss')}} {{ dataTemplate.sr_representative }}
                    </div>
                </div>
                <div class="vx-row   w-full mb-6 items-center">
                    <div class="vx-col sm:w-1/6 w-full">
                    <span>관리자 메모</span>
                    </div>
                    <div class="vx-row noWrap vx-col sm:w-5/6 w-full ">
                        <vs-textarea v-model="dataTemplate.memo" class="w-full sm:w-5/6" height='100px' placeholder=""/>
                        <vs-button color="success" class="ml-3" @click.native="saveMemo()" type="filled">저장</vs-button>
                    </div>
                </div>
                 
            </div>
        </vx-card>
        <vx-card title="발매승인 정보" class="mb-6" v-if="dataTemplate.album_id" >
            <div class="w-full vx-row">
                <div class="vx-row w-full mb-6 items-center">
                    <div class="vx-col sm:w-1/6 w-full">
                        <span>발매확정일</span>
                    </div>
                    <div class="vx-col sm:w-1/3 w-full textLeft">
                        <datepicker 
                            class="vx-col w-full"
                            :value="dataTemplate.album.release_date"
                            format="yyyy-MM-dd"
                            :language="ko"
                            disabled
                        />
                    </div> 
                    <div class="vx-col sm:w-1/6 w-full">
                        <span>발매확정시간</span>
                    </div>
                    <div class="vx-col sm:w-1/3 w-full textLeft">
                        <v-select class="searchSelect"  
                        :value="dataTemplate.album.release_time" 
                        :options="optionData.hour"
                        :reduce="dateOption => dateOption.value"
                        :clearable="false"
                        disabled
                        />
                    </div>
                </div>
                <div class="vx-col m-auto mt-6">
                    <vs-button  :href="'/album/detail/'+dataTemplate.album_id" target="_blank" >
                        앨범 상세보기
                    </vs-button> 
                </div>
            </div>
        </vx-card>
        <vx-card title="신청 앨범 정보" class="mb-6">
            <div class="w-full vx-row">
                <div class="vx-row w-full mb-6 items-center">
                    <div class="vx-col sm:w-1/6 w-full">
                        <span>발매 희망일시</span>
                    </div>
                    <div class="vx-col sm:w-1/3 w-full ">
                        {{ dataTemplate.desired_release_date }}
                        
                        {{ fixDate('2000-01-01 '+ dataTemplate.desired_release_time, 'HH:mm') }}
                    </div>
                    <div class="vx-col sm:w-1/6 w-full">
                        발매자료완성일
                    </div>
                    <div class="vx-col sm:w-1/3 w-full">
                        {{ dataTemplate.ready_date }}
                    </div>
                </div>
                <div class="vx-row w-full mb-6 items-center">
                    
                </div>
                <div class="vx-row   w-full mb-6 items-center">
                    <div class="vx-col sm:w-1/6 w-full">
                    <span>발매 앨범명</span>
                    </div>
                    <div class="vx-col sm:w-1/3 w-full ">
                       {{ dataTemplate.album_title }}
                    </div>
                </div>
                <div class="vx-row   w-full mb-6 items-center">
                    <div class="vx-col sm:w-1/6 w-full">
                    <span>참여 아티스트 </span>
                    </div>
                    <div class="vx-col sm:w-1/3 w-full ">
                        {{ dataTemplate.album_artist }}
                    </div>
                </div>
                <div class="vx-row   w-full mb-6 items-center">
                    <div class="vx-col sm:w-1/6 w-full">
                    <span>아티스트 스트리밍 URL </span>
                    </div>
                    <div class="vx-col sm:w-5/6 w-full ">
                        <vs-textarea v-model="dataTemplate.url_artist" class="w-full " height='100px' placeholder="" disabled/>
                    </div>
                </div>
                <div class="vx-row   w-full mb-6 items-center">
                    <div class="vx-col sm:w-1/6 w-full">
                    <span>앨범관련 첨부파일링크 </span>
                    </div>
                    <div class="vx-col sm:w-5/6 w-full ">
                        {{ dataTemplate.url_demo }}
                    </div>
                </div>
                <div class="vx-row   w-full mb-6 items-center">
                    <div class="vx-col sm:w-1/6 w-full">
                    <span>MV 포함여부 </span>
                    </div>
                    <div class="vx-col sm:w-5/6 w-full ">
                        {{ dataTemplate.has_mv ? 'Y' : 'N' }}
                    </div>
                </div>
                <div class="vx-row   w-full mb-6 items-center">
                    <div class="vx-col sm:w-1/6 w-full">
                    <span>요청사항 </span>
                    </div>
                    <div class="vx-col sm:w-5/6 w-full ">
                        <vs-textarea v-model="dataTemplate.remark" class="w-full " style="resize: auto;" height='200px' placeholder="" disabled />
                    </div>
                </div>
            </div>
        </vx-card>
        <vx-card title="임시 삭제 사유" class="mb-6" v-if=" dataTemplate.state ==  'trash'">
            <div class="w-full vx-row">
                 
                <div class="vx-row   w-full mb-6 items-center">
                    
                    <div class="vx-col sm:w-6/6 w-full ">
                        <vs-textarea v-model="dataTemplate.trash_memo" class="w-full " style="resize: auto;" height='200px' placeholder="" disabled />
                    </div>
                </div>
            </div>
        </vx-card>
        <div class="vx-row">
            <div class="vx-col m-auto mt-6" v-if=" dataTemplate.state !=  'trash'">
                <vs-button @click="$router.push('/calendar')" type="filled">이전</vs-button>
                <vs-button v-if=" dataTemplate.state !=  'approved'" color="rgb(125 125 125)" class="ml-3" @click.native="openDelete" type="filled">임시삭제</vs-button>
                <vs-button v-if="dataTemplate.state != 'approved' && dataTemplate.state !=  'rejected'" color="danger"  class="ml-3" @click.native="putReject" type="filled">발매거절</vs-button>
                <vs-button v-if="dataTemplate.state != 'on_hold' && dataTemplate.state !=  'approved'" color="warning" class="ml-3" @click.native="putHold" type="filled">발매보류</vs-button>
                <vs-button v-if=" dataTemplate.state !=  'approved'" color="success" class="ml-3" @click.native="openApprove" type="filled">발매승인</vs-button>
            </div>
            <div class="vx-col m-auto mt-6" v-else>
                <vs-button @click="$router.push('/calendar')" type="filled">이전</vs-button>
                <vs-button color="success" class="ml-3" @click.native="putRestore" type="filled">신청 복구</vs-button>
            </div>
        </div>

        <v-modal name="approve" 
            :width="'100%'"
            :maxWidth="1000"
            height="auto"
            :adaptive="true"
            >
            <div class="onlyDark">
                <div style="padding:0.5rem 1rem; font-size: 16px;" class="card-color ">
                    <strong style="font-size:16px; " class="modalCont darkWhiteColor">발매일 승인</strong>
                </div>
                <div style="padding:1rem; text-align:center; word-break:keep-all; font-size: 15px;" class="modalCont " >
                    <div class="vx-row   w-full mb-6 items-center">
                        <div class="vx-col sm:w-1/6 w-full">
                            <span>발매희망일</span>
                        </div>
                        <div class="vx-col sm:w-1/3 w-full textLeft">
                            
                            <datepicker 
                                class="vx-col w-full"
                                :value="dataTemplate.desired_release_date"
                                format="yyyy-MM-dd"
                                :language="ko"
                                disabled
                            />
                        </div> 
                        <div class="vx-col sm:w-1/6 w-full">
                            <span>발매희망시간</span>
                        </div>
                        <div class="vx-col sm:w-1/3 w-full textLeft">
                            <v-select class="searchSelect"  
                            :value="dataTemplate.desired_release_time" 
                            v-model='dataTemplate.desired_release_time' 
                            :options="[{label:'12:00', value:'12:00:00'},{label:'18:00', value:'18:00:00'}]"
                            :reduce="dateOption => dateOption.value"
                            :clearable="false" 
                            disabled
                            />
                        </div>
                    </div>
                    <div class="vx-row   w-full mb-6 items-center">
                        <div class="vx-col sm:w-1/2 w-full"> 
                            
                                <div class="mb-6">
                                    <date-picker 
                                        :lang="lang"
                                        v-model="approveData.release_date"
                                        value-type="format"
                                        format="YYYY-MM-DD"
                                        :clearable='true'
                                        inline
                                        @change="daySet"
                                    />
                                </div>
                                <div class="vx-row   w-full mb-6 items-center">
                                    <div class="vx-col sm:w-1/3 w-full">
                                    <span>발매확정일</span>
                                    </div>
                                    <div class="vx-col sm:w-2/3 w-full textLeft">
                                        <datepicker 
                                                class="vx-col w-full"
                                                :value="approveData.release_date"
                                                format="yyyy-MM-dd"
                                                :language="ko"
                                                disabled
                                            />
                                    </div>
                                </div>
                                <div class="vx-row   w-full mb-6 items-center">
                                    <div class="vx-col sm:w-1/3 w-full">
                                    <span>발매시간</span>
                                    </div>
                                    <div class="vx-col sm:w-2/3 w-full textLeft">
                                        <v-select class="searchSelect"  
                                            
                                            :value="approveData.release_time" 
                                            v-model='approveData.release_time' 
                                            :options="optionData.hour"
                                            :reduce="dateOption => dateOption.value"
                                            :clearable="false" 
                                            />
                                    </div>
                            </div>
                        </div>
                        <div class="vx-col sm:w-1/2 w-full" style="height: 450Px;">
                            <FullCalendar
                                id="fullCalendarDay"
                                :options="calendarDayOptions"
                                ref="fullCalendarDay"
                            >
                            <template v-slot:eventContent='data'>
                                <div class='calendarInfo' v-if="data.view.type == 'dayGridMonth'">
                                <div @click="openMonthAlert(data)">
                                    임시저장 : {{data.event.extendedProps.data.temporary}}  <br>
                                    접수 : {{data.event.extendedProps.data.registration_complete}}  <br>
                                    검수완료 : {{data.event.extendedProps.data.inspection_complete}}  <br>
                                    유통완료 : {{data.event.extendedProps.data.distribution_complete}}  <br>
                                    발매완료 : {{data.event.extendedProps.data.release_complete}}  <br><br>
                                </div>
                                <p  @click="openEditSlot(data.event.extendedProps.data)"><span class='count'>발매확정 : {{data.event.extendedProps.data.count_albums}} </span> / <span class='slot'>SLOT : {{data.event.extendedProps.data.count_slots}} </span></p>  
                                </div>
                                <div v-else>
                                    <div class='calendarInfo' style="position: relative;">
                                    <span class='count'>발매확정 : {{data.event.extendedProps.data.count_albums}} </span> / <span class='slot'>SLOT : {{data.event.extendedProps.data.count_slots}} </span>
                                    </div>
                                    <ul class="calendarAlbumList mt-5" v-if="data.event.extendedProps.data.albums">
                                    <li class="" v-for="item,index in data.event.extendedProps.data.albums" @click="handleEventClick(item)">
                                        <div :class="[{'t_only_korea' :item.tags_v2.indexOf('t_only_korea') > -1} ,{'t_except_korea' :item.tags_v2.indexOf('t_except_korea') > -1 }]">
                                            <p style="font-size: 13px;">{{item.artists}} - {{item.name}} / {{item.licensor}} / {{item.release_type ? item.release_type.toUpperCase() : '-'}} / {{ item.track_count}}</p>
                                            <p style="font-size:12px; font-weight: bold;">
                                                <!-- <span v-for="tag in item.tags_v2">
                                                    {{tagList[tag]}}
                                                </span> -->
                                                <span v-if="item.tags_v2.indexOf('exposure') > -1">※</span>
                                                <span v-if="item.tags_v2.indexOf('magazine') > -1">★</span>
                                                <span v-if="item.tags_v2.indexOf('release_time') > -1">☾</span>
                                                <span v-if="item.tags_v2.indexOf('has_mv') > -1">M</span>
                                                <span v-if="item.tags_v2.indexOf('has_beat') > -1">B</span>
                                                <span v-if="item.tags_v2.indexOf('marketing_rec') > -1">♣</span>
                                                <span v-if="item.tags_v2.indexOf('genre_ccm') > -1">✝</span>
                                                <span v-if="item.tags_v2.indexOf('t_only_korea') > -1">K</span>
                                                <span v-if="item.tags_v2.indexOf('t_except_korea') > -1">G</span>
                                                <!-- 'exposure' : '※', 
                                                'magazine' : '★', 
                                                'release_time' : '☾', 
                                                'has_mv' : 'M', 
                                                'has_beat' : 'B', 
                                                'marketing_rec' : '♣', 
                                                'genre_ccm' :'✝', 
                                                't_only_korea' : 'K', 
                                                't_except_korea' :'G' -->
                                            </p>
                                        </div>
                                    </li>
                                    </ul>
                                <!-- <span class='count'>발매확정 : {{data.event.extendedProps.data.count_albums}} </span> / <span class='slot'>SLOT : {{data.event.extendedProps.data.count_slots}} </span>   -->
                                </div>
                            </template>
                            </FullCalendar>
                        </div>
                    </div>
                     <div class="vx-row">
                        <div class="vx-col m-auto mt-6 mb-6">
                            <vs-button color="danger" @click.native="closeModal('approve')" type="filled">취소</vs-button>
                            <vs-button color="success" class="ml-3" @click.native="putApprove" type="filled">발매승인</vs-button>
                        </div>
                    </div>
                </div>
            </div>
        </v-modal>
        <v-modal name="calendar" 
            :width="'100%'"
            :maxWidth="400"
            height="auto"
            :adaptive="true"
            >
            <div class="onlyDark">
                <div style="padding:0.5rem 1rem; font-size: 16px;" class="card-color ">
                <strong style="font-size:16px; " class="modalCont darkWhiteColor">일정 상세보기</strong>
                </div>
                <div style="padding:1rem; text-align:center; word-break:keep-all; font-size: 15px;" class="modalCont darkWhiteColor" >
                <div style='text-align:left' v-if=" Object.keys(popData).length > 0">
                    <div >
                        태그 : 
                        <p style="font-size: 12px; font-weight: bold; display: inline;">
                            <span v-if="popData.tags_v2.indexOf('exposure') > -1"> ※ </span>
                            <span v-if="popData.tags_v2.indexOf('magazine') > -1"> ★ </span>
                            <span v-if="popData.tags_v2.indexOf('release_time') > -1"> ☾ </span>
                            <span v-if="popData.tags_v2.indexOf('has_mv') > -1"> M </span>
                            <span v-if="popData.tags_v2.indexOf('has_beat') > -1"> B </span>
                            <span v-if="popData.tags_v2.indexOf('marketing_rec') > -1"> ♣ </span>
                            <span v-if="popData.tags_v2.indexOf('genre_ccm') > -1"> ✝ </span>
                            <span v-if="popData.tags_v2.indexOf('t_only_korea') > -1"> K </span>
                            <span v-if="popData.tags_v2.indexOf('t_except_korea') > -1"> G </span>
                        </p>
                    </div>
                    앨범명 : {{popData.name}}
                    <br/>
                    권리자명 : {{popData.licensor}}
                    <br/>
                    아티스트 : {{popData.artists}}
                    <br/>
                    앨범형식 : {{popData.release_type? popData.release_type.toUpperCase() : popData.release_type}}
                    <br/>
                    트랙수 : {{popData.track_count}}
                    <br/>
                    담당자 : {{popData.sr_representative}}
                    <p>
                    
                    <router-link :to="{ path: '/album/detail/'+ popData.id }" style="float:right;" target="_blank"> 
                        <button style="padding:5px 10px; background:rgba(var(--vs-primary), 1) !important; border:0; border-radius: 5px; color :#fff; font-size: 13px;">
                        앨범 상세보기
                        </button>
                    </router-link>
                    </p>
                    <br/>
                </div>
                </div>
            </div>
        </v-modal>
        <v-modal name="delete"
            :width="'100%'"
            :maxWidth="400"
            height="auto"
            :adaptive="true"
            >
            <div class="onlyDark">
                <div style="padding:0.5rem 1rem; font-size: 16px;" class="card-color ">
                <strong style="font-size:16px; " class="modalCont darkWhiteColor">임시삭제</strong>
                </div>
                <div style="padding:1rem; text-align:center; word-break:keep-all; font-size: 15px;" class="modalCont darkWhiteColor" >
                    <vx-card >
                        <vs-textarea v-model="deleteReason" class="w-full " height='100px' placeholder="임시삭제 사유" />
                    </vx-card>
                    <div class="vx-row">
                        <div class="vx-col m-auto mt-6 mb-6">
                            <vs-button color="danger" @click.native="closeModal('delete')" type="filled">취소</vs-button>
                            <vs-button color="success" class="ml-3" @click.native="putDelete" type="filled">임시삭제</vs-button>
                        </div>
                    </div>
                </div>
            </div>
        </v-modal>
        <v-modal name="reject"
            :width="'100%'"
            :maxWidth="420"
            height="auto"
            :adaptive="true"
            >
            <div class="onlyDark">
                <div style="padding:0.5rem 1rem; font-size: 16px;" class="card-color ">
                    <strong style="font-size:16px;" class="modalCont darkWhiteColor">발매거절</strong>
                </div>
                <div style="padding:1.5rem 1rem 1rem; word-break:keep-all; font-size: 15px;" class="modalCont darkWhiteColor">
                    <p style="margin-bottom:1rem;">거절 유형을 선택해주세요.</p>
                    <vx-card>
                        <div style="display:flex; flex-direction:column; gap:12px; padding:4px 0;">
                            <label style="display:flex; align-items:center; gap:10px; cursor:pointer;">
                                <input type="radio" v-model="rejectType" value="normal" style="width:16px; height:16px; cursor:pointer;" />
                                <span>일반 거절</span>
                            </label>
                            <label style="display:flex; align-items:center; gap:10px; cursor:pointer;">
                                <input type="radio" v-model="rejectType" value="ai" style="width:16px; height:16px; cursor:pointer;" />
                                <span>AI 음악 거절</span>
                            </label>
                        </div>
                    </vx-card>
                    <div class="vx-row">
                        <div class="vx-col m-auto mt-6 mb-6">
                            <vs-button color="danger" @click.native="closeModal('reject')" type="filled">취소</vs-button>
                            <vs-button color="success" class="ml-3" @click.native="doReject" type="filled">거절확인</vs-button>
                        </div>
                    </div>
                </div>
            </div>
        </v-modal>
    </div>
</template>

<script>
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction'
import optionData from '@/optionData/data'
import {ko} from 'vuejs-datepicker/dist/locale'
import agTableComp from '@/optionData/agTableComp'

const today = new Date()
export default{
    data () {
        return{
            optionData: optionData,
            ko : ko,
            lang :{
                
                months: ["1월","2월","3월","4월","5월","6월","7월","8월","9월","10월","11월","12월",],
                // MMM
                monthsShort: ["1월","2월","3월","4월","5월","6월","7월","8월","9월","10월","11월","12월",],
                // dddd
                weekdays:["일", "월", "화", "수", "목", "금", "토"],
                // ddd
                weekdaysShort: ["일", "월", "화", "수", "목", "금", "토"],
                // dd
                weekdaysMin: ["일", "월", "화", "수", "목", "금", "토"],
                // first day of week
                firstDayOfWeek: 0,
                // first week contains January 1st.
                firstWeekContainsDate: 1,
                days: ["일", "월", "화", "수", "목", "금", "토"],
                months: ["1월","2월","3월","4월","5월","6월","7월","8월","9월","10월","11월","12월",],
                yearFormat: "YYYY년",
                monthFormat: "MM월",
                // the calendar title of month before year
                monthBeforeYear: false,

            },
            startDate : null,
            endDate : null,
            calendarDayOptions: {
                locale: 'ko',
                plugins: [dayGridPlugin,interactionPlugin],
                theme: true,
                headerToolbar: {
                left: 'prev',
                center: 'title',
                right: 'next',
                },
                selectable: false,
                selectHelper: true,
                editable: false,
                initialView: 'dayGridDay',
                initialDate: today,
                initialEvent: this.events,
                events : this.events,
                height: '100%',
                //eventsSet: this.handleEvents,
                eventLimit: true,
                
                dateClick:this.handleDateClick,
                fixedWeekCount: false,
                eventColor: 'transparent',
                customButtons: {
                prev: {
                    text: 'PREV',
                    click: () => {
                        const calendarApi = this.$refs.fullCalendarDay.getApi()
                        calendarApi.prev()
                        const currentStart = calendarApi.view.activeStart
                        this.dayCall(currentStart)
                    
                    },
                },
                next: {
                    text: 'NEXT',
                    click: () => {
                        const calendarApi = this.$refs.fullCalendarDay.getApi()
                        calendarApi.next()
                        const currentStart = calendarApi.view.activeStart
                        console.log(calendarApi.view.activeStart);
                        this.dayCall(currentStart)
                        
                    },
                },
                today: {
                    text: 'TODAY',
                    click: () => {
                    const calendarApi = this.$refs.fullCalendarDay.getApi()
                    calendarApi.today()
                    const currentStart = calendarApi.view.activeStart
                    this.selectMonth = currentStart  
                    },
                },
                },
                
            },
            dataTemplate : {
                "id": null,
                "album_id": null,
                "licensor_id": null,
                "email": null,
                "phone": null,
                "entity": null,
                "name": null,
                "company":null,
                "country":null,
                "release_experience":null,
                "url_release":null,
                "url_sns":null,
                "url_demo":null,
                "album_title":null,
                "album_artist":null,
                "url_artist":null,
                "has_mv":null,
                "desired_release_date":null,
                "desired_release_time":null,
                "ready_date": null,
                "remark":null,
                "language":null,
                "state":null,
                "source":null,
                "memo":null,
                "sr_representative":null,
                "created_at":null,
                "updated_at": null,
                "state_updated_at": null,
                
            },
            selectLicensor: [],
            userTable :{
                defaultColDef: {
                    sortable: false,
                    editable: false,
                    resizable: true,
                    suppressMenu: false,
                    rowSelection:'single'
                },
                gridOptions :{ // 테이블 옵션 (같은 페이지에 있을때 공유해서 쓰면 에러)
                    context: {
                        componentParent: this
                    },
                    onGridReady: function (event) {
                    },
                    frameworkComponents : agTableComp
                },
                columnDefs: [
                    {headerName: 'E-mail ID', field: 'email', filter: false,width: 220,},
                    {headerName: '권리자명 (성 이름)', field: 'licensor.family_name', filter: false,width: 150,
                        cellRenderer: (data) => {
                        let fm = data.data.licensor.family_name ? data.data.licensor.family_name : '';
                        let gm = data.data.licensor.given_name ? data.data.licensor.given_name : '' ;
                        return fm +' '+ gm
                    }},
                    {headerName: '회사명', field: 'licensor.company', filter: false,width: 150,},
                    
                    {headerName: '정산화폐', field: 'licensor.currency', filter: false,width: 150,
                        cellRenderer: (data) => {
                        const type = {
                            'krw' : 'KRW',
                            'usd' : 'USD',
                            'eur' : 'EUR',
                        }
                        return type[data.value]
                    }},
                    {headerName: '사업자여부', field: 'licensor.entity', filter: false,width: 150, cellRenderer: (data) => {
                        const type = {
                            'individual' : '개인',
                            'corporation' : '사업자',
                        }
                        return type[data.value]
                    }},
                    {headerName: '거주국가',  field: 'licensor.entity_address.country',  filter: false,width: 155,},
                    {headerName: 'MIMS',  field: 'licensor.mims_account',  filter: false,width: 155,},
                    {headerName: '정산요율', field: 'licensor.default_service_fee_kr', filter: false,width: 200, cellRenderer: (data) => {
                        let text = ""
                        text += "국내 : " + data.value + '%   '
                        text += "해외 : " + data.data.licensor.default_service_fee_other + '%'
                        return text
                    }},
                    {headerName: '상세보기', field: 'id', filter: false,width: 120,cellRenderer: (data) => {
                        return `<a class="vs-component vs-button mr-3 vs-button-primary vs-button-gradient" href='/member/detail/${data.value}' target="_blank">
                        
                        <span class="vs-button-text vs-button--text">상세보기</span>
                        </a>`
                    }},
                ],
                
            },

            rejectType: 'normal',
            approveData : {release_date: null, release_time: null },

            popData : {},
            deleteReason : null,
        }
    },
    watch: {
        
    },
    mounted () {
        this.$nextTick((vue) =>{
            if(this.$route.params){
                this.call();
            
            }
        })
    },
     
    methods:{
        call(){
            let payload = {
                id : `${this.$route.params.id}`
            }
            this.$store.dispatch('GET_APPLICATION_DETAIL', payload)
            .then(result =>{
                console.log(result)
                let t = result;
                this.dataTemplate = {
                    ...result
                }
                this.selectLicensor = [{
                    ...t.licensor.user,
                    licensor : t.licensor
                }]
            }).catch(error=>{
                
            })
        },
        typeText(val){
            let dd = {
                registered : "발매신청",
                approved : '발매승인',
                rejected : '발매거절',
                on_hold : '발매보류',
                trash : '임시삭제'
            }
            let color = {
                registered : "#4aa414",
                approved : '#2935b5',
                rejected : '#ba2727',
                on_hold : '#c3a433',
                trash : '#808080'
            }
            let html =  `
            <div class="con-vs-chip vs-chip-primary con-color" 
            style="
                cursor : pointer;
                background-color: ${color[val]} !important;
                color:#fff;
                line-height:1;
                padding:3px 10px;
                margin:10px 0; 
                font-size:13px;
                min-width:50px;
            ">
                <span style="margin:0" class="text-chip vs-chip--text">
                ${dd[val]}
            </span><!----></div>`
            return html
        },
        putReject(){
            this.rejectType = 'normal'
            this.openModal('reject')
        },
        doReject(){
            const payload = {
                id : `${this.$route.params.id}`,
                params: { reject_type: this.rejectType }
            }
            this.loadingShow()
            this.$store.dispatch("PUT_APPLICATION_REJECT", payload)
            .then(() => {
                this.loadingHide();
                this.closeModal('reject')
                this.noti('처리 되었습니다.')
                this.call()
            }).catch(error => {
                this.loadingHide();
                switch(error.response.data.code) {
                    default:
                    this.alert({msg:error})
                    break;
                }
            })
        },
        putHold(){
            let payload = {
                id : `${this.$route.params.id}`
            }
            this.confirm({
                title : '발매 보류',
                msg : `
                    발매 신청을 보류하시겠습니까?
                    
                `,
                autofocus : true,
                width:400,
                action : ()=>{
                    this.loadingShow()
                    this.$store.dispatch("PUT_APPLICATION_HOLD", payload)
                    .then(result =>{
                        this.loadingHide();
                        this.noti('처리 되었습니다.')
                        this.call()
                    }).catch(error =>{
                        this.loadingHide();
                        switch(error.response.data.code) {
                            default:
                            this.alert({msg:error})
                            break;
                    }
                    })
                }
            })
        },
        openApprove(){
            this.approveData = {
                release_date : this.dataTemplate.desired_release_date,
                release_time : this.dataTemplate.desired_release_time
            }
            this.dayCall(this.dataTemplate.desired_release_date)
            this.openModal('approve')
        },
        putApprove(){
            let payload = {
                id : `${this.$route.params.id}`,
                params: {
                    ...this.approveData
                }
            }
            this.confirm({
                title : '발매 승인 ',
                msg : `
                    발매 신청을 승인하시겠습니까?
                    
                `,
                autofocus : true,
                width:400,
                action : ()=>{
                    this.loadingShow()
                    this.$store.dispatch("PUT_APPLICATION_APPROVE", payload)
                    .then(result =>{
                        this.loadingHide();
                        this.noti('처리 되었습니다.')
                        this.closeModal('approve')
                        this.call()
                    }).catch(error =>{
                        this.loadingHide();
                        switch(error.response.data.code) {
                            default:
                            this.alert({msg:error})
                            break;
                    }
                    })
                }
            })
        },
        dayCall(date){
            console.log(date)
            let format = this.fixDate(date, 'yyyy-MM-dd')
            let payload = {
                start : format
            }
            this.loadingShow()
            this.$store.dispatch('GET_CALENDAR_DAY', payload)
            .then(result =>{
                this.loadingHide()
                console.log(result);
                this.calendarDayOptions.events = []
                const calendarApi = this.$refs.fullCalendarDay.getApi()
                calendarApi.gotoDate(date) 
                result.forEach((album,index) => {
                    const event = {}
                    event.id = index 
                    event.start = album.date
                    event.extendedProps = {}
                    event.extendedProps.data = album
                    event.extendedProps.title = 'ddd'
                    this.calendarDayOptions.events.push(event)
                })
            }).catch(error=>{
                this.loadingHide()
                 
            })
        },
        daySet(date){
            console.log(date)
            const calendarApi = this.$refs.fullCalendarDay.getApi()
            calendarApi.gotoDate(date)
            this.dayCall(date)
        },

        saveMemo(){
            
            let payload = {
                id : `${this.$route.params.id}`,
                params : {
                    memo : this.dataTemplate.memo
                }
            }
            this.loadingShow()
            this.$store.dispatch('PUT_APPLICATION_MEMO', payload)
            .then(result =>{
                this.loadingHide()
                this.dataTemplate = {
                    ...result
                }
            }).catch(error=>{
                this.loadingHide()
                 
            })
        },
        handleEventClick (info) {
            this.popData = info
            this.openModal('calendar')
        },
        openDelete(){
            this.deleteReason = null
            this.openModal('delete')
        },
        putDelete(){
            let payload = {
                id : `${this.$route.params.id}`,
                params: {
                    trash_memo : this.deleteReason
                }
            }
            if(this.valCheck(this.deleteReason)){
                this.alert({msg:'삭제 사유를 입력해주세요.'});
                return false
            }
            this.confirm({
                title : '발매 요청 삭제',
                msg : `
                    발매 신청을 임시삭제하시겠습니까?
                `,
                autofocus : true,
                width:400,
                action : ()=>{
                    this.loadingShow()
                    this.$store.dispatch("PUT_APPLICATION_TRASH", payload)
                    .then(result =>{
                        this.loadingHide();
                        this.noti('처리 되었습니다.')
                        this.closeModal('delete')
                        this.call()
                    }).catch(error =>{
                        this.loadingHide();
                        switch(error.response.data.code) {
                            default:
                            this.alert({msg:error})
                            break;
                    }
                    })
                }
            })
        },
        putRestore(){
            let payload = {
                id : `${this.$route.params.id}`,
                params: {
                }
            }
            this.confirm({
                title : '신청 복구 ',
                msg : `
                    임시삭제하신 발매 신청을 복구하시겠습니까?
                    
                `,
                autofocus : true,
                width:400,
                action : ()=>{
                    this.loadingShow()
                    this.$store.dispatch("PUT_APPLICATION_RESTORE", payload)
                    .then(result =>{
                        this.loadingHide();
                        this.noti('처리 되었습니다.')
                        this.call()
                    }).catch(error =>{
                        this.loadingHide();
                        switch(error.response.data.code) {
                            default:
                            this.alert({msg:error})
                            break;
                    }
                    })
                }
            })
        }
    }
}
</script>

<style lang="scss">

</style>
